import DepartmentsPageView from "./DepartmentsPageView";

function DepartmentsPage() {
  return <DepartmentsPageView />;
}

export default DepartmentsPage;
